import { FormTranslation, TRANSLATION_TYPE } from '../../Types/forms';

/**
 * Resolves a translated text value from a translations array.
 * Returns the first match for the given type.
 * TODO: Accept cultureId parameter for multi-language support.
 */
export const getTranslatedText = (translations: FormTranslation[], type: number): string => {
	return translations.find((t) => t.type === type)?.value ?? '';
};

/** Shorthand for getting the name translation. */
export const getOptionName = (translations: FormTranslation[]): string => {
	return getTranslatedText(translations, TRANSLATION_TYPE.NAME);
};

/** Shorthand for getting the description translation. */
export const getOptionDescription = (translations: FormTranslation[]): string => {
	return getTranslatedText(translations, TRANSLATION_TYPE.DESCRIPTION);
};
